var exports = {
  "container": "xe533113f--3c25b0--container",
  "container--size-m": "xe533113f--3c25b0--container--size-m",
  "container--size-s": "xe533113f--3c25b0--container--size-s",
  "container--active": "xe533113f--3c25b0--container--active",
};

module.exports = exports;
